import { ComponentProps, Suspense } from 'react';

import { useIsMounted } from '~hooks/useIsMount';

type SuspenseProps = Omit<ComponentProps<typeof Suspense>, 'fallback'>;

interface Props extends SuspenseProps {
  pendingFallback: ComponentProps<typeof Suspense>['fallback'];
}

const SSRSafeSuspense = ({ pendingFallback, children }: Props) => {
  const isMounted = useIsMounted();

  if (!isMounted) return null;

  return <Suspense fallback={pendingFallback}>{children}</Suspense>;
};

export default SSRSafeSuspense;
